/**
 * @generated SignedSource<<f5671f5d7d0407fbc821692a547020d1>>
 * @relayHash 584eeb631668d23b8ce4c3a29c749dba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c4196b100b8db9b0ae7d8f1871949cbfc381146b4a3a957518c8bac7c4b59c77

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ContentRepresentationV2 = "atlas_doc_format" | "editor" | "editor2" | "export_view" | "plain" | "raw" | "storage" | "styled_view" | "view" | "wiki" | "%future added value";
export type MacroRendererMode = "EDITOR" | "PDF" | "RENDERER" | "%future added value";
export type multiMacroQueryQuery$variables = {
  after?: string | null | undefined;
  blocklist?: ReadonlyArray<string> | null | undefined;
  contentId: string;
  first?: number | null | undefined;
  mode?: MacroRendererMode | null | undefined;
  refetchToken?: string | null | undefined;
};
export type multiMacroQueryQuery$data = {
  readonly macros: {
    readonly nodes: ReadonlyArray<{
      readonly contentId: string;
      readonly macroId: string;
      readonly renderedMacro: {
        readonly macroBodyStorage: string | null | undefined;
        readonly macroRenderedRepresentation: ContentRepresentationV2 | null | undefined;
        readonly mediaToken: {
          readonly token: string | null | undefined;
        } | null | undefined;
        readonly value: string | null | undefined;
        readonly webResource: {
          readonly contexts: ReadonlyArray<string | null | undefined>;
          readonly keys: ReadonlyArray<string | null | undefined>;
          readonly superbatch: {
            readonly metatags: string | null | undefined;
          } | null | undefined;
          readonly tags: {
            readonly css: string | null | undefined;
            readonly data: string | null | undefined;
            readonly js: string | null | undefined;
          } | null | undefined;
          readonly uris: {
            readonly css: ReadonlyArray<string | null | undefined> | null | undefined;
            readonly data: ReadonlyArray<string | null | undefined> | null | undefined;
            readonly js: ReadonlyArray<string | null | undefined> | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
    };
  } | null | undefined;
};
export type multiMacroQueryQuery = {
  response: multiMacroQueryQuery$data;
  variables: multiMacroQueryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blocklist"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": "RENDERER",
  "kind": "LocalArgument",
  "name": "mode"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refetchToken"
},
v6 = [
  {
    "kind": "ScalarField",
    "name": "css"
  },
  {
    "kind": "ScalarField",
    "name": "data"
  },
  {
    "kind": "ScalarField",
    "name": "js"
  }
],
v7 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "blocklist",
        "variableName": "blocklist"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "refetchToken",
        "variableName": "refetchToken"
      }
    ],
    "concreteType": "MacroConnection",
    "kind": "LinkedField",
    "name": "macros",
    "plural": false,
    "selections": [
      {
        "concreteType": "PageInfoV2",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasNextPage"
          },
          {
            "kind": "ScalarField",
            "name": "endCursor"
          }
        ]
      },
      {
        "concreteType": "Macro",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "macroId"
          },
          {
            "kind": "ScalarField",
            "name": "contentId"
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "mode",
                "variableName": "mode"
              }
            ],
            "concreteType": "RenderedMacro",
            "kind": "LinkedField",
            "name": "renderedMacro",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "value"
              },
              {
                "kind": "ScalarField",
                "name": "macroRenderedRepresentation"
              },
              {
                "kind": "ScalarField",
                "name": "macroBodyStorage"
              },
              {
                "concreteType": "WebResourceDependenciesV2",
                "kind": "LinkedField",
                "name": "webResource",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "contexts"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "keys"
                  },
                  {
                    "concreteType": "SuperBatchWebResourcesV2",
                    "kind": "LinkedField",
                    "name": "superbatch",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "metatags"
                      }
                    ]
                  },
                  {
                    "concreteType": "WebResourceTagsV2",
                    "kind": "LinkedField",
                    "name": "tags",
                    "plural": false,
                    "selections": (v6/*: any*/)
                  },
                  {
                    "concreteType": "WebResourceUrisV2",
                    "kind": "LinkedField",
                    "name": "uris",
                    "plural": false,
                    "selections": (v6/*: any*/)
                  }
                ]
              },
              {
                "concreteType": "EmbeddedMediaTokenV2",
                "kind": "LinkedField",
                "name": "mediaToken",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "token"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "multiMacroQueryQuery",
    "selections": (v7/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "multiMacroQueryQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "584eeb631668d23b8ce4c3a29c749dba",
    "id": "c4196b100b8db9b0ae7d8f1871949cbfc381146b4a3a957518c8bac7c4b59c77",
    "metadata": {},
    "name": "multiMacroQueryQuery",
    "operationKind": "query",
    "text": "query multiMacroQueryQuery($contentId:ID!,$mode:MacroRendererMode=RENDERER,$blocklist:[String!],$first:Int,$after:String,$refetchToken:String)@allowHigherTimeout{macros(contentId:$contentId,blocklist:$blocklist,first:$first,after:$after,refetchToken:$refetchToken){pageInfo{hasNextPage,endCursor},nodes{macroId,contentId,renderedMacro(mode:$mode){value,macroRenderedRepresentation,macroBodyStorage,webResource{contexts,keys,superbatch{metatags},tags{css,data,js},uris{css,data,js}},mediaToken{token}}}}}"
  }
};
})();

(node as any).hash = "5967875eb6ab4194db64d8e7a4b9d76a";

export default node;
